import store from '../../store';
const getFeelingTagCheck = (date = new Date()) => {
  const userRewardSummary = store.getState().missionAndReward.rewardSummary;
  if (!userRewardSummary) {
    return false;
  }
  // get a hongkong time date
  const hongkongTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Hong_Kong' }));
  // format the date to YYYY-MM-DD
  const daytag = `${hongkongTime.getFullYear()}-${String(hongkongTime.getMonth() + 1).padStart(2, '0')}-${String(
    hongkongTime.getDate()
  ).padStart(2, '0')}`;
  const feelingTag = userRewardSummary?.feelings?.[daytag];
  if (feelingTag) {
    return true;
  }
  return false;
};

export default getFeelingTagCheck;
